/* global femcare, Swiper */

femcare.gallery.article = {

    init: function () {
        var $galleries = $('.article-gallery');

        if ($galleries.length) {

            $galleries.each(function (index, gallery) {
                var $swiper = $(gallery).find('.article-gallery__content');
                var initGallery = $swiper.find('.article-gallery__item').length > 1;

                if (initGallery) {
                    new Swiper($swiper[0], {
                        slidesPerView: 1,
                        spaceBetween: 30,
                        pagination: {
                            el: '.article-gallery__pagination',
                            type: 'bullets',
                            bulletElement: 'button',	
                            clickable: true,
                            bulletClass: 'article-gallery__page',
                            bulletActiveClass: 'article-gallery__page--active'
                        }
                    });
                }
            });
        }
    }
}